module.exports = __webpack_public_path__ + "static/media/contact.082aa0df.jpg";